import React from 'react';
import PropTypes from 'prop-types';
import {
  Modal,
  Typography,
  Row,
} from 'antd';

import ModalDeleteControls from './ModalDeleteControls';

const { Text } = Typography;

const ModalLimpiar = ({
  onDelete,
  onCancel,
  content,
  open,
  loading,
}) => (
  <Modal
    title={(
      <Row justify="space-between">
        <Text>
          Eliminación
        </Text>
        <ModalDeleteControls
          onDelete={onDelete}
          onCancel={onCancel}
          loading={loading}
        />
      </Row>
    )}
    className="modal-delete"
    open={open}
    footer={null}
    closable={false}
    maskClosable={!loading}
    keyboard={!loading}
    destroyOnClose
  >
    {typeof content === 'string' ? (
      <>
        <Text style={{ fontSize: 16 }}>
          ¿Desea Limpiar
          {' '}
          {content}
          ?
        </Text>
        <Text>
          Esta acción no podrá revertirse
        </Text>
      </>
    ) : (
      content
    )}
  </Modal>
);

ModalLimpiar.propTypes = {
  onDelete: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
  content: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.node,
  ]).isRequired,
  open: PropTypes.bool,
  loading: PropTypes.bool,
};

ModalLimpiar.defaultProps = {
  open: false,
  loading: false,
};

export default ModalLimpiar;
